<ng-container *ngIf="!item.value.activeLotIdField; else toggleLotDropdown">
  <span
    class="text-underline cursor-pointer"
    (dblclick)="onEditLineItem(purchaseOrderItemField, paginationLength + index)"
  >
    {{ item?.value?.selectedLot?.label || '-- None --' }}
  </span>
</ng-container>
<ng-template #toggleLotDropdown>
  <mat-select
    #matSelectComponent="matSelect"
    class="lum-input w-50"
    [disabled]="!item.value.activeLotIdField"
    [value]="item?.value?.lotId"
    (selectionChange)="
      onSelectLotEvent($event, index, item?.value?.lotId, matSelectComponent)
    "
    (openedChange)="onOpenLotListEvent($event, index)"
  >
    <mat-option *ngIf="isLotsLoading" disabled>-- Loading --</mat-option>
    <mat-option *ngIf="!isLotsLoading" disabled>-- None --</mat-option>
    <mat-option
      *ngIf="item?.value?.lotId && !lotsByRfqId[item.value.rfqId]?.length"
      [value]="item?.value?.selectedLot?.value"
    >
      {{ item?.value?.selectedLot?.label }}
    </mat-option>
    <mat-option *ngFor="let lot of lotsByRfqId[item.value.rfqId]" [value]="lot.id">
      {{ lot.lot_number }}
    </mat-option>
    <mat-option class="divider-option" disabled></mat-option>
    <mat-option [value]="'createANewLot'"> Create a new Lot </mat-option>
  </mat-select>
</ng-template>
